import React, {createContext, useContext, useEffect, useState} from 'react';
import {setAuthClear, setAuthGetter, setAuthSetter} from "./api/api";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
    const [token, setTokenState] = useState(() => sessionStorage.getItem('token'));
    const [sid, setSidState] = useState(sessionStorage.getItem('sid'));
    const [refresh, setRefresh] = useState(false);
    const [permissions, setPermissionsState] = useState({read:false, write:false});

    const [userName, setUserNameState] = useState(sessionStorage.getItem("userName"));

    useEffect(() => {
        setAuthGetter(() => ({ token, sid })); // ✅ pass a function that returns the latest values
        setAuthClear(clear)
        setRefresh(!refresh)
    }, [token, sid]);


    const setToken = (newToken) => {
        setTokenState(newToken);
        sessionStorage.setItem('token', newToken);
    };

    const setSid = (newSid) => {
        setSidState(newSid)
        sessionStorage.setItem('sid', newSid);
    }

    const setUserName = (val) => {
        setUserNameState(val)
        sessionStorage.setItem('userName', val)
    }

    const getToken = token;
    const getSid = sid

    const setPermissions = (permissions) => {
        setPermissionsState(permissions);
    }

    const clear = () => {
        setTokenState(null)
        setSidState(null)

        sessionStorage.removeItem('token');
        sessionStorage.removeItem('sid');

        setUserName("")
    }

    return (
        <AppContext.Provider value={{ setToken, getToken, getSid, setSid, clear, refresh, setPermissions, permissions, userName, setUserName }}>
            {children}
        </AppContext.Provider>
    );
};

export const useApp = () => {
    const context = useContext(AppContext);
    if (!context) {
        throw new Error('useApp must be used within an AppProvider');
    }
    return context;
};
